// import React from 'react';
import React, { Fragment, useState, useEffect, useCallback } from "react";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { Add, Sub, Reset } from "./cartActions";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import { postItemsUpdate } from "./api";

export default function CartTotalsCart(props) {

    const options = {

        "key": "rzp_test_GRTZ7YhuI9ST2Z", // Enter the Key ID generated from the Dashboard
        "key_id": "SIWPFHJ8HNE4byw43ab350WH",
        "amount": props.totalPrice,
        "currency": "INR",
        "description": "FIS Payment",
        "image": "https://s3.amazonaws.com/rzp-mobile/images/rzp.jpg",
        "prefill":
        {
            "email": "vijay.at@clsslabs.com",
            "contact": 8122859937,
            "name": ""
        },
        handler: function (response) {
            
            alert("", response.razorpay_payment_id)
        }
    };


    //   new Razorpay({
    //     "key": "rzp_test_GRTZ7YhuI9ST2Z",
    //     "key_id": "SIWPFHJ8HNE4byw43ab350WH",
    //     "amount": props.totalPrice,
    //     "currency": "INR",
    //     "description": "FIS Payment",
    //     "image": "https://s3.amazonaws.com/rzp-mobile/images/rzp.jpg",
    //     "prefill":
    //     {
    //         "email": "vijay.at@clsslabs.com",
    //         "contact": 8122859937,
    //         "name": ""
    //     },
    // });

    const handleReset = () => {
        
        Reset();
        // if (this.props.loggedIn) {
        // await postItemsUpdate('Reset')
        // }
    };


    const openrazorpay = async () => {
        const self = this;

        const options = {
            key: 'rzp_test_9fQCBhrXEO7Ql5',
            amount: props.totalPrice * 100,
            name: 'Razorpay Payments',
            description: 'FIS Payments',

            handler(response) {
                
                console.log("response.razorpay_payment_id", response)
                console.log("response.razorpay_payment_id", response.razorpay_payment_id)

                const paymentId = response.razorpay_payment_id;
                const url = process.env.URL + '/api/v1/rzp_capture/' + paymentId + '/' + props.totalPrice;
                // Using my server endpoints to capture the payment

                fetch(url, {
                    method: 'get',
                    headers: {
                        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                    }
                })
                // .then(function (response) {
                //     

                // })

                if (!response) {
                    
                    swal("Oops", "Order Error, Please Try Later", "error");
                } else {
                    
                    handleReset();
                    swal("Success!", `Order Placed - ID : ${paymentId}`, "success");
                    // console.log('Request succeeded with JSON response', response);
                    // self.setState({
                    //     refund_id: response.razorpay_payment_id
                    // });
                    window.location.href = '/fis/foods/cart';
                }

                // .catch(function (error) {
                //     
                //     console.log('Request failed', error);
                //     handleReset();
                //     swal("Oops", "Order Error, Please Try Later", "error");
                // });


            },

            prefill:
            {
                "email": "vijay.at@clsslabs.com",
                "contact": 8122859937,
                "name": "vijay"
            },

            notes: {
                address: ',India',
            },
            theme: {
                color: '#9D50BB',
            },
        };
        const rzp1 = new window.Razorpay(options);

        rzp1.open();
    }


    return (
        <div>
            <h4 className='text-uppercase my-auto'>Order Summary</h4>
            <Card className='mt-3'>
                <Card.Header className='pl-2 font-weight-bold'>
                    {props.total} Products
                </Card.Header>
                <Card.Body className='d-flex justify-content-between p-2 mt-3'>
                    <Card.Text>
                        Products Price
                    </Card.Text>
                    <Card.Text>
                        ₹ {props.totalPrice}
                    </Card.Text>
                </Card.Body>

                <Card.Body className='d-flex justify-content-between p-2'>
                    <Card.Text>
                        Delivery
                    </Card.Text>
                    <Card.Text>
                        ₹ {30.00}
                    </Card.Text>
                </Card.Body>

                ------------------------------------------------------
                <Card.Body className='d-flex justify-content-between p-2'>
                    <Card.Text>
                        Total
                    </Card.Text>

                    <Card.Text>
                        ₹  {props.totalPrice + 30.00}
                    </Card.Text>
                </Card.Body>
                --------------------------------------------------------

                <Card.Footer>
                    {/* <Link to='checkout'> */}
                    <Button variant='warning' block disabled={props.disabled}
                        onClick={() => { openrazorpay() }}
                    >
                        {/* {props.buttonText} */}
                        Place Order
                    </Button>
                    {/* </Link> */}
                    <hr />

                    {/* <h6 className='mt-3'>
                        WE ACCEPT:
                        <Image className="img-thumbnail mt-1" src="https://assets.asosservices.com/asos-finance/images/marketing/single.png"
                            alt="payment options" />
                    </h6>
                    <p style={{ fontSize: '0.8em' }}>
                        Got a coupon code? Add it in the next step
                    </p> */}
                </Card.Footer>
            </Card>
        </div>
    );
}